$(function(){
    //显示下拉框
    $("body").on('click','.drop-down .btn,.report-drop .report-btn',function(event){
        if($(this).parent().hasClass('open')){
            $(this).parent().removeClass('open');
        }else{
            $(".drop-down").removeClass('open');
            $(this).parent().addClass('open');
        }
        event.stopPropagation();
    })
    //点击下拉选项
    $("body").on('click','.drop-down .option li,.report-down',function(event){
        event.stopPropagation();
        if($(this).hasClass('repTem')){
            $(this).parents('.drop-down').removeClass('open');
            return;
        }
        if($(this).hasClass('disabled')){
            return;
        }
        $(this).parents('.drop-down').removeClass('open');
        
    })
    $("body").on('click',function(){
        $(".drop-down,.report-drop").removeClass('open');
    })
    function screenHeight(){
        var h = $(window).height() - 274;
        $(".content").css('min-height',h)
        $(".mdCont,.leftMenu,.mrCont").css('min-height',h)
    }
    screenHeight(); 
    $(window).resize(function() {
       screenHeight(); 
    });
})

export default {
    data() {
        return {
            aletrTimer:''
        }
    },
    // 时间转化
    dateConversion (date,type) {
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        month = month < 10 ? '0' + month : month;
        let day = date.getDate();
        day = day < 10 ? '0' + day : day;
        let hour = date.getHours();
        hour = hour < 10 ? '0' + hour : hour;
        let minute = date.getMinutes();
        minute = minute < 10 ? '0' + minute : minute; 
        let second = date.getSeconds();
        second = second < 10 ? '0' + second : second; 
        if(type == 0){//年月日
            return year + '-' + month + '-' + day;
        }else if(type == 1){//年月日时分
            return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':'+second;
        }
        
    },
    alertText (text,width,time) {
        $(".alertText").remove();
        clearTimeout(this.aletrTimer);
        let html = '<div class="alertText ac" style="width:'+width+'px;"><div class="in">'+text+'</div></div>';
        $("body").append(html);
        if(time == undefined){
            time = 2000;
        }
        this.aletrTimer = setTimeout(() => {
            $(".alertText").remove();
        }, time);
    },
    //计算时间跨度
    getDateDiff(startDate,endDate){  
        let startTime = new Date(Date.parse(startDate.replace(/-/g,   "/"))).getTime();     
        let endTime = new Date(Date.parse(endDate.replace(/-/g,   "/"))).getTime();     
        let dates = Math.abs((startTime - endTime))/(1000*60*60*24);     
        return  dates;    
    },
    // 检测数组位置
    indexOf(arr, str){
        // 如果可以的话，调用原生方法
        if(arr && arr.indexOf){
            return arr.indexOf(str);
        }
         
        let len = arr.length;
        for(let i = 0; i < len; i++){
            // 定位该元素位置
            if(arr[i] == str){
                return i;
            }
        }
         
        // 数组中不存在该元素
        return -1;
    },
    // 获取当前时间
    getNowDate(type) {//获取当前时间
        let date = new Date();
        let seperator1 = "-";
        let seperator2 = ":";
        let month = date.getMonth() + 1<10? "0"+(date.getMonth() + 1):date.getMonth() + 1;
        let strDate = date.getDate()<10? "0" + date.getDate():date.getDate();
        let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
        let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        let currentdate = '';
        if(type === 0){//不带时分秒
            currentdate = date.getFullYear() + seperator1  + month  + seperator1  + strDate
        }else{//带时分秒
            currentdate = date.getFullYear() + seperator1  + month  + seperator1  + strDate
            + " "  + h  + seperator2  + m
            + seperator2 + s;
        }
        return currentdate;
    },
    // 获取当前时间前的时间 天数自定义
    getBeforeDay(date,num){
        var date = date || new Date(),
            timestamp, 
            newDate;
        if(!(date instanceof Date)){
            date = new Date(date.replace(/-/g, '/'));
        }
        timestamp = date.getTime();
        newDate = new Date(timestamp - num * 24 * 3600 * 1000);
        let month = newDate.getMonth() + 1;
        month = month.toString().length == 1 ? '0' + month : month; 
        let day = newDate.getDate().toString().length == 1 ? '0' + newDate.getDate() :newDate.getDate();
        return [newDate.getFullYear(), month, day].join('-');
    },
    // 时间转化毫秒
    millisecondTodate (str) {
        let arr = str.split(/[-:\s \/]/);
        let date = Date.parse(new Date(arr[0], arr[1]-1, arr[2], arr[3], arr[4], arr[5]));
        return date;
    },
    dateTab(date1,date2){
        var oDate1 = new Date(date1);
        var oDate2 = new Date(date2);
        if(oDate1.getTime() > oDate2.getTime()){
            return date1;
        } else {
            return date2;
        }
    },
    // 计算
    getWeek(i,time) {
        let now = new Date();
        let miao1 = now.getHours()*3600 + now.getMinutes()*60;
        time = time.split(':');
        let miao2 = parseInt(time[0])*3600 + parseInt(time[1])*60;
        let currWeek = now.getDay() - 1;
        
        if((i <= currWeek && miao1 > miao2)||(i < currWeek)){
            i = 7-(currWeek - i);
        }else{
            i = i-currWeek
        }
        let firstDay=now;
        firstDay.setDate(firstDay.getDate() + i);
        let mon = Number(firstDay.getMonth()) + 1;
        mon = mon.toString().length == 1 ? '0' + mon : mon;
        let day = firstDay.getDate().toString().length == 1 ? '0' + firstDay.getDate() :firstDay.getDate(); 
        return now.getFullYear() + "-" + mon + "-" + day;
    },
    screenHeight(){
        var h = $(window).height() - 274;
        $(".content").css('min-height',h)
        $(".mdCont,.leftMenu,.mrCont").css('min-height',h)
    }
}


// WEBPACK FOOTER //
// ./src/utils/index.js